import { render } from "./TvmServiceTypes.vue?vue&type=template&id=a52686a8&scoped=true"
import script from "./TvmServiceTypes.js?vue&type=script&lang=js&external"
export * from "./TvmServiceTypes.js?vue&type=script&lang=js&external"

import "./TvmServiceTypes.vue?vue&type=style&index=0&id=a52686a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a52686a8"],['__file',"src/components/ChatWidget/TvmServiceTypes/TvmServiceTypes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a52686a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a52686a8', __exports__)) {
    api.reload('a52686a8', __exports__)
  }
  
  module.hot.accept("./TvmServiceTypes.vue?vue&type=template&id=a52686a8&scoped=true", () => {
    api.rerender('a52686a8', render)
  })

}


export default __exports__